import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AscentLoginHeroConfig } from '../../ascent-login.config';

@Component({
  selector: 'app-login-hero',
  templateUrl: './login-hero.component.html',
  styleUrls: ['./login-hero.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginHeroComponent {
  @Input() hero: AscentLoginHeroConfig;
  @Input() showProductLogo = true;
  @Input() productLogoUrl = '';
  @Output() ctaClick = new EventEmitter<void>();
}
